
import "./servicelist.css";
import { DataGrid } from "@mui/x-data-grid";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useState, useEffect } from "react";
import AddButton from "../../components/addButton/AddButton";
import API_URL from "../../config/api";

const SERVICES_API_URL = `${API_URL}/api/services`;

const ServiceList = () => {
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        image: null,
    });

    useEffect(() => {
    fetch(SERVICES_API_URL)
    .then((res) => res.json())
    .then((res) => {
      const clean = Array.isArray(res)
        ? res.filter((item) => item?.id && item?.name)
        : [];

      setData(clean);
    })
    .catch(() => setData([]));
}, []);

    const uploadToCloudinary = async (file) => {
        const form = new FormData();
        form.append("file", file);
        form.append("upload_preset", "SulavSewa");

        const res = await fetch(
            "https://api.cloudinary.com/v1_1/dknqhkkhy/image/upload",
            {
                method: "POST",
                body: form,
            }
        );

        const result = await res.json();

        if (!result.secure_url) {
            throw new Error("Image upload failed");
        }

        return result.secure_url;
    };

    // ✅ HANDLE INPUT
    const handleChange = (e) => {
        const { name, value, files } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: files ? files[0] : value,
        }));
    };

    // ✅ ADD SERVICE

    const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        let imageUrl = "";

        if (formData.image) {
            const form = new FormData();
            form.append("file", formData.image);
            form.append("upload_preset", "SulavSewa");

            const res = await fetch(
                "https://api.cloudinary.com/v1_1/dknqhkkhy/image/upload",
                {
                    method: "POST",
                    body: form,
                }
            );

            const result = await res.json();

            if (!result.secure_url) {
                throw new Error("Image upload failed");
            }

            imageUrl = result.secure_url;
        }

        const payload = {
            name: formData.name,
            image: imageUrl,
        };

        const res = await fetch(SERVICES_API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (!res.ok) {
            throw new Error(data.message || "Failed to add service");
        }

        const updated = await fetch(SERVICES_API_URL);
        const result = await updated.json();

        setData(Array.isArray(result) ? result : []);

        setOpen(false);
        setFormData({ name: "", image: null });

    } catch (error) {
        console.error("Submit error:", error);
        alert(error.message);
    }
};

    // ✅ DELETE SERVICE
    const handleDelete = async (id) => {
        try {
            await fetch(`${SERVICES_API_URL}/${id}`, {
                method: "DELETE",
            });

            setData((prev) => prev.filter((item) => item.id !== id));
        } catch (error) {
            console.error("Delete error:", error);
        }
    };

    // ✅ TABLE COLUMNS
    const columns = [
        { field: "id", headerName: "ID", width: 80 },

        {
            field: "service",
            headerName: "Service",
            width: 250,
            renderCell: (params) => (
                <div className="serviceListItem">
                    <img
                        src={
                            params.row?.image ||
                            "https://dummyimage.com/40x40"
                        }
                        alt=""
                        className="serviceListImg"
                    />
                    {params.row?.name || "No Name"}
                </div>
            ),
        },

        {
            field: "action",
            headerName: "Action",
            width: 150,
            renderCell: (params) => (
                <DeleteOutlineIcon
                    className="serviceListDelete"
                    onClick={() => handleDelete(params.row.id)}
                />
            ),
        },
    ];

    return (
        <div className="serviceList">
            <div className="serviceListTop">
                <h2>Services</h2>
                <AddButton label="Add Service" onClick={() => setOpen(true)} />
            </div>

            {/* ✅ DATA GRID (FIXED) */}
            <DataGrid
                rows={data}
                columns={columns}
                pageSizeOptions={[5, 8, 10]}
                checkboxSelection
                getRowId={(row) => row.id}
            />

            {/* MODAL */}
            {open && (
                <div className="modalOverlay">
                    <div className="modal">
                        <h2>Add Service</h2>

                        <form className="modalForm" onSubmit={handleSubmit}>
                            <input
                                name="name"
                                placeholder="Service Name"
                                onChange={handleChange}
                                required
                            />

                            <input
                                name="image"
                                type="file"
                                onChange={handleChange}
                                required
                            />

                            <div className="modalButtons">
                                <button type="submit" className="submitBtn">
                                    Add
                                </button>

                                <button
                                    type="button"
                                    className="cancelBtn"
                                    onClick={() => setOpen(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ServiceList;